import { Text } from "@mantine/core";

import { ChecklistCheckbox } from "./ChecklistCheckbox";

interface Props {
  checked: any;
  index: number;
  onChange: (e: any) => void;
  disabled?: boolean;
}
const NaCheckbox = ({ index, ...props }: Props) => {
  return (
    <ChecklistCheckbox
      variant="na"
      size="md"
      key={`check-n/a-${index}`}
      label={<Text style={{ whiteSpace: "nowrap" }}>N/A</Text>}
      labelPosition="left"
      name={String(index)}
      style={{ flex: 1 }}
      {...props}
    />
  );
};
export default NaCheckbox;
